import { Injectable } from '@angular/core';
import {
    ValueMetricLimit,
    GetValueMetric,
    ValueMetricTransactionQuery
} from '../../core-data-model/ValueMetrics';
import { ValueMetricsApiConnect } from './value-metrics.connect';

@Injectable({ providedIn: 'root' })
export class ValueMetricsService {
    constructor(private api: ValueMetricsApiConnect) {}

    async getValueMetricConfig(
        valueMetricRequest: GetValueMetric
    ): Promise<ValueMetricLimit> {
        return await this.api.getValueMetricLimit(valueMetricRequest);
    }

    async getValueMetricConfigs() {
        return this.api.getValueMetrics();
    }

    async getValueMetricTransactions(
        valueMetricTransactionQuery: ValueMetricTransactionQuery
    ) {
        return this.api.getValueMetricTransactions(valueMetricTransactionQuery);
    }
}
